var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F49E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1122 9.75037C12.3756 7.77094 13.3594 4.5 13.3594 4.5L11.2528 4.97756L10.4816 7.70569C10.4091 5.66044 9.00675 4.91175 9.00675 4.91175C7.88344 4.36444 6.88219 4.60519 6.1605 4.9815C5.26725 5.44612 4.61756 6.25612 4.3065 7.18875C3.86437 8.51569 3.91837 10.0046 3.97687 10.6785C4.0005 10.9946 4.07025 11.3057 4.185 11.6027C4.96012 13.6125 7.10719 13.4983 7.10719 13.4983C9.07425 13.4286 10.2696 11.1122 10.2696 11.1122L10.8332 12.8154C11.3383 13.6699 12.4571 13.3498 12.6872 13.302C12.7277 13.293 12.7637 13.2885 12.8047 13.2795L14.0625 13.0877V12.5404C11.3242 12.6146 11.1122 9.75037 11.1122 9.75037ZM8.4465 11.8091C8.27712 11.9827 8.06357 12.1068 7.82888 12.168C7.31869 12.2951 6.92663 12.0808 6.65606 11.8181C6.35379 11.5129 6.14682 11.1263 6.06037 10.7055C5.56425 7.89862 6.24994 6.66844 6.70556 6.10313C6.82967 5.94465 6.98966 5.81795 7.17235 5.73345C7.35503 5.64895 7.55519 5.60908 7.75631 5.61713C9.52481 5.70938 9.92194 9.4095 9.92194 9.4095C9.42131 10.7229 8.77612 11.4851 8.4465 11.8091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgrs);
export default __webpack_public_path__ + "static/media/agrs.362d9603bc17464c50f58be4b101564e.svg";
export { ForwardRef as ReactComponent };